import { LinearProgress, Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CollaborationStepContainer } from 'features/collaboration-base/components';
import { TeamingReason } from 'features/teaming/teaming-base/enums';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';

interface TeamSearchProps {
  reason: TeamingReason;
  onCancel: () => void;
}

export const TeamSearch: FC<TeamSearchProps> = ({ reason, onCancel }) => {
  const { t: ct } = useTranslation();
  const { t } = useTranslation('translation', {
    keyPrefix: 'teamSearch',
  });

  return (
    <CollaborationStepContainer testId='team-search'>
      <LinearProgress />
      {/* TODO: update text styles when Doug finish it in Figma */}
      <Typography
        data-testid='team-search-title'
        variant='body1'
        color={theme.palette.grey[50]}
        mt={8}
      >
        {reason === TeamingReason.Handoff
          ? ct('handoffSearchTitle')
          : t('teamTitle')}
      </Typography>
      <Typography variant='body2' color={theme.palette.common.white} mt={8}>
        {ct('searchingNextInterpreter')}
      </Typography>
      <CancelButton
        fullWidth
        size='small'
        color='secondary'
        title={ct('cancel')}
        onClick={onCancel}
        autoFocus
      >
        {ct('cancel')}
      </CancelButton>
    </CollaborationStepContainer>
  );
};

const CancelButton = styled(Button)`
  margin-top: ${theme.spacing(8)};
`;
